__turbopack_context__.v({
  "wishlist-form": "wishlist-form-component-module-scss-module__97csSq__wishlist-form",
});
